import React, { useEffect } from "react";
import Classes from "./styles/style.module.css";
import ForgetpassRenewPage from "./ForgetpassRenewPage";
import ForgetpassFirstpage from "./ForgetpassFirstpage";
import { useSelector } from "react-redux/es/hooks/useSelector";
import AnimatedPageContainer from "../../assets/containers/AnimatedPageContainer";

const ForgetPass = () => {
  const { showNationalCodeDialog } = useSelector(({ user }) => user);

  useEffect(() => {
    document.body.classList.add("profileBg");
    return () => {
      document.body.classList.remove("profileBg");
    };
  }, []);

  return (
    <AnimatedPageContainer>
      <div className={Classes.loginContainer}>
        <div className={Classes.contentContainer}>
          {showNationalCodeDialog ? (
            <ForgetpassFirstpage />
          ) : (
            <ForgetpassRenewPage />
          )}
        </div>
      </div>
    </AnimatedPageContainer>
  );
};

export default ForgetPass;
